export default __webpack_public_path__ + "static/media/logo512.80e31ef1.png";